export default __webpack_public_path__ + "static/media/banner-img3.e0ef9206.png";